import { FormType } from "@/enums";
import { IFormField, IIntake } from "@/interfaces";
import {
  camelCaseFixIntakeForm,
  fetchBaseQueryWrapper,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

interface ICategory {
  id: string;
}

export const formsApi = createApi({
  reducerPath: "formsApi",
  baseQuery: fetchBaseQueryWrapper(),
  endpoints: (build) => ({
    getProductCategoryForms: build.query<
      { [key in FormType]: IFormField[] },
      string | void
    >({
      query: (productCategory) => `admin/forms/${productCategory || ""}`,
      transformResponse: ({ data }) => ({
        // TODO: Be be removed during Cosmos DB update
        [FormType.Intake]: camelCaseFixIntakeForm(data.intake),
        categories:
          data.categories?.reduce(
            (previousValue: ICategory, currentValue: ICategory) => ({
              ...previousValue,
              [currentValue.id]: currentValue,
            }),
            {}
          ) || {},
      }),
    }),
    getFormLookups: build.query<{ [FormType.Intake]: IIntake }, void>({
      query: () => "forms/lookup",
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const { useGetProductCategoryFormsQuery, useGetFormLookupsQuery } =
  formsApi;
